import { Checkbox } from "antd";
import PropTypes from "prop-types";

const BillingVehicleMobileCard = ({ vehicle, showCheckbox, checked, onCheckChange, checkDisabled, actions }) => (
    <article className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
        <div className="flex items-start gap-3">
            {showCheckbox ? (
                <Checkbox
                    className="mt-0.5"
                    checked={checked}
                    disabled={checkDisabled}
                    onChange={(e) => onCheckChange(e.target.checked)}
                />
            ) : null}
            <div className="min-w-0 flex-1">
                <p className="text-base font-semibold text-[#2F2F46]">{vehicle?.name || "—"}</p>
                <dl className="mt-2 space-y-1.5 text-sm">
                    <div className="flex justify-between gap-3">
                        <dt className="shrink-0 text-gray-500">VIN</dt>
                        <dd className="min-w-0 break-all text-right font-medium text-[#2F2F46]">
                            {vehicle?.vin || "—"}
                        </dd>
                    </div>
                    <div className="flex justify-between gap-3">
                        <dt className="shrink-0 text-gray-500">Plate</dt>
                        <dd className="text-right font-medium text-[#2F2F46]">{vehicle?.plate || "—"}</dd>
                    </div>
                    <div className="flex justify-between gap-3">
                        <dt className="shrink-0 text-gray-500">Type</dt>
                        <dd className="text-right font-medium text-[#2F2F46]">{vehicle?.bodyType || "—"}</dd>
                    </div>
                </dl>
                {actions ? <div className="mt-3 flex flex-wrap gap-2">{actions}</div> : null}
            </div>
        </div>
    </article>
);

BillingVehicleMobileCard.propTypes = {
    vehicle: PropTypes.object.isRequired,
    showCheckbox: PropTypes.bool,
    checked: PropTypes.bool,
    onCheckChange: PropTypes.func,
    checkDisabled: PropTypes.bool,
    actions: PropTypes.node,
};

export default BillingVehicleMobileCard;
